import OrdersPage from '@/pages/shared/OrdersPage'

/**
 * Sales sees every order in the company but cannot edit shipment details or
 * open a job sheet - neither route exists under /sales.
 */
export default function SalesOrders() {
  return <OrdersPage basePath="/sales" canEditShipment={false} canOpenJobSheet={false} showMineFilter canProceed="own" />
}
